/**
 * @module common/components/tabbed_navigation
 */
import React, { Component, PropTypes } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import { v4 } from 'node-uuid';
import Tab from 'common/components/navigation_tab';
import { isUrlActive } from 'common/utils';
import NavigationDropdown from 'common/components/navigation_dropdown';

/**
 * TabbedNavigation - component for displaying tabs/responsive dropdown component.
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 * @author Jing Wang <jing@crowdspring.com>
 */
export default class TabbedNavigation extends Component {
  formatUrl(url) {
    /* check if the url contains any named params and get them from router */
    const { router } = this.props;
    const namedParams = url.match(/\(:\w+\)/);
    let newUrl = url;

    if (namedParams) {
      const param = namedParams[0].replace(/\W/g, '');
      const paramValue = router.params[param];

      if (param) {
        newUrl = url.replace(namedParams[0], paramValue);
      }
    }

    return newUrl;
  }

  getLinksInfo(links) {
    const { router } = this.props;

    /* augment list of links with information used to properly render tabs/dropdown */
    return links.map((link) => {
      let url = '';
      let isActive = false;
      let subItems = null;

      /* tab has no sub-items */
      if (!link.subItems) {
        url = this.formatUrl(link.url);
        isActive = isUrlActive(url, router.location.pathname, link.matchExact, link.regex);
      /* tab has sub-items */
      } else {
        subItems = [];
        link.subItems.map((item) => {
          const itemUrl = this.formatUrl(item.url);
          const isItemActive = isUrlActive(
            itemUrl, router.location.pathname, item.matchExact, item.regex
          );

          /* if one of the sub-items is active, make the tab active as a consequence */
          if (isItemActive) {
            isActive = true;
          }

          subItems.push({ component: item.component, url: itemUrl, isActive: isItemActive });
        });
      }

      return {
        title: link.name,
        isActive: isActive,
        url: url,
        subItems: subItems,
      };
    });
  }

  renderTabs(linksInfo) {
    return (
      <ul className="header-tabs dropdown">
        { linksInfo.map(({ url, title, isActive, subItems }) => (
            <Tab key={v4()} to={url} title={title} isActive={isActive} subItems={subItems}/>
          )
        )}
      </ul>
    );
  }

  render() {
    const { tabs, rightDropdown, dropdownOnly } = this.props;
    if (!tabs || !tabs.links || !tabs.links.length) {
      return null;
    }
    const linksInfo = this.getLinksInfo(tabs.links);

    return (
      <div className="tabbed-navigation">
        <div className={classnames({ "show-for-small-only": !dropdownOnly })}>
          <NavigationDropdown links={linksInfo} right={rightDropdown} />
        </div>
        { !dropdownOnly &&
        <div className="tab-wrapper tabs hide-for-small-only">
          { this.renderTabs(linksInfo) }
        </div> }
      </div>
    );
  }
}

TabbedNavigation.propTypes = {
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string,
    }),
  }).isRequired,
  tabs: PropTypes.shape({
    links: PropTypes.arrayOf(PropTypes.shape({
      url: PropTypes.string,
      name: PropTypes.string,
      subItems: PropTypes.array
    })),
  }),
  rightDropdown: PropTypes.bool,
  dropdownOnly: PropTypes.bool
};



// WEBPACK FOOTER //
// ./common/components/tabbed_navigation.jsx